import { commonjsGlobal as _ } from "../../../_virtual/_commonjsHelpers.js";
import { c as v } from "./lib/card-types.js";
import "./lib/add-matching-cards-to-results.js";
import "./lib/is-valid-input-type.js";
import "./lib/find-best-match.js";
import "./lib/clone.js";
import { __exports as R } from "../../../_virtual/clone.js";
import { __exports as C } from "../../../_virtual/add-matching-cards-to-results.js";
import { __exports as E } from "../../../_virtual/is-valid-input-type.js";
import { __exports as y } from "../../../_virtual/find-best-match.js";
var d = _ && _.__assign || function() {
  return d = Object.assign || function(r) {
    for (var t, e = 1, a = arguments.length; e < a; e++) {
      t = arguments[e];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (r[s] = t[s]);
    }
    return r;
  }, d.apply(this, arguments);
}, l = v, I = C, h = E, A = y, c = R, p = {}, n = {
  VISA: "visa",
  MASTERCARD: "mastercard",
  AMERICAN_EXPRESS: "american-express",
  DINERS_CLUB: "diners-club",
  DISCOVER: "discover",
  JCB: "jcb",
  UNIONPAY: "unionpay",
  MAESTRO: "maestro",
  ELO: "elo",
  MIR: "mir",
  HIPER: "hiper",
  HIPERCARD: "hipercard"
}, m = [
  n.VISA,
  n.MASTERCARD,
  n.AMERICAN_EXPRESS,
  n.DINERS_CLUB,
  n.DISCOVER,
  n.JCB,
  n.UNIONPAY,
  n.MAESTRO,
  n.ELO,
  n.MIR,
  n.HIPER,
  n.HIPERCARD
], i = c.clone(m);
function u(r) {
  return p[r] || l[r];
}
function O() {
  return i.map(function(r) {
    return c.clone(u(r));
  });
}
function f(r, t) {
  t === void 0 && (t = !1);
  var e = i.indexOf(r);
  if (!t && e === -1)
    throw new Error('"' + r + '" is not a supported card type.');
  return e;
}
function o(r) {
  var t = [];
  if (!h.isValidInputType(r))
    return t;
  if (r.length === 0)
    return O();
  i.forEach(function(a) {
    var s = u(a);
    I.addMatchingCardsToResults(r, s, t);
  });
  var e = A.findBestMatch(t);
  return e ? [e] : t;
}
o.getTypeInfo = function(r) {
  return c.clone(u(r));
};
o.removeCard = function(r) {
  var t = f(r);
  i.splice(t, 1);
};
o.addCard = function(r) {
  var t = f(r.type, !0);
  p[r.type] = r, t === -1 && i.push(r.type);
};
o.updateCard = function(r, t) {
  var e = p[r] || l[r];
  if (!e)
    throw new Error('"' + r + "\" is not a recognized type. Use `addCard` instead.'");
  if (t.type && e.type !== t.type)
    throw new Error("Cannot overwrite type parameter.");
  var a = c.clone(e);
  a = d(d({}, a), t), p[a.type] = a;
};
o.changeOrder = function(r, t) {
  var e = f(r);
  i.splice(e, 1), i.splice(t, 0, r);
};
o.resetModifications = function() {
  i = c.clone(m), p = {};
};
o.types = n;
var N = o;
export {
  N as d
};
